<script>

import {discountServiceList, getAvailableServiceList, getUserServiceList} from "@/api/subscriptions";

import * as organizationApi from '@/api/organizations';
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  name: 'SubscriptionDetailsPage',
  components: {},
  data() {

    this.setStep(1)

    let services = []

    let selected_services = []

    let discounts = []

    let active_services = []
    getUserServiceList().then(
        (response) => {
          this.active_services = [...response.data.active_services, ...response.data.awaiting_services]
        }
    )

    discountServiceList().then(
        (json) => {
          this.discounts = json.data.data.periods
          this.setDiscounts(json.data.data.periods)
        }
    )

    getAvailableServiceList().then(
        (json) => {
          this.services = json.data.data.services
        }
    )

    return {
      services: services,
      selected_services: selected_services,
      durations: [],
      organizations: [],
      query: '',
      discounts: discounts,
      active_services: active_services
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters('subscription', [
      'isChecked',
      'isModalVisible',
      'getBusySlots',
      'getSlots',
      'getItemSlots',
      'isSlotPresented',
      'getStep',
      'getItems',
      'getState',
      'getServices',
      'getItemSlotsList',
      'getDiscount'
    ]),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    serviceNum() {
      return this.services.filter(service => this.isChecked(service.id)).length;
    },
    getSum() {
      return this.getServices().map(
          (service) => {

            let discount = (100 - this.getDiscount(service.id))/ 100;
            return service.price_per_unit * this.getItemSlotsList(service.id).duration * this.getSlots(service.id) * discount;
          }
      ).reduce((acc, item) => acc + item, 0)
    }
  },
  methods: {
    ...mapActions('subscription', ['setSlots', 'hideModal', 'showModal', 'toggleItemSlot', 'setDiscounts', 'setStep', 'toggleService']),
    async load() {
      let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE);
      this.organizations = response.data.data.map(
          (item) => {
            return {
              id: item.id,
              name: item.short_name,
              inn: item.inn
            }
          }
      )
    },
    getFinishDate(service) {
      const duration = this.getItemSlotsList(service.id).duration
      return this.getServiceStartDate(service.id).add(duration, 'M').format('D.MM.Y')
    },
    getStartDate(id) {
      return this.getServiceStartDate(id).format('D.MM.Y')
    },
    getServiceStartDate(id) {
      const index = this.active_services.map(param => param.service_id).lastIndexOf(id)
      if (this.active_services[index]) {
        if (moment(this.active_services[index].subscription_finish_date) > moment()) {
          return moment(this.active_services[index].subscription_finish_date, 'YYYY-MM-DD')
        }
      }
      return moment()
    }
  }
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container">
      <div class="ais24--steps">
        <ul class="ais24--steps__list">
          <li class="ais24--steps__item" :class="getStep() === 0 ? ' active': ''">Подписка на сервисы</li>
          <li class="ais24--steps__item" :class="getStep() === 1 ? ' active': ''">Детали подписки</li>
          <li class="ais24--steps__item" :class="getStep() === 2 ? ' active': ''">Оплата</li>
        </ul>
      </div>
      <header class="ais24--header">
        <h2 class="ais24--title">Детали подписки</h2>
      </header><!--/.ais24--header-->
      <div class="ais24--details">
        <div class="ais24--details__content">
          <div class="ais24--selected-subscriptions">

            <div class="ais24--selected-subscriptions-card" v-for="service in getServices()" v-bind:key="service.id">
              <div class="ais24--selected-subscriptions-card__headline">
                <h4 class="ais24--selected-subscriptions-card__title">Сервис &laquo;{{ service.name }}&raquo;</h4>
                <div class="ais24--selected-subscriptions-card__actions">
                  <button class="ais24--button" type="button">
                                            <span class="ais24--button__icon">
                                                <svg class="ais24--icon ais24--icon--18x18">
                                                    <use xlink:href="/img/sprite.svg#icon-18-trash"></use>
                                                </svg>
                                            </span>
                    <span class="ais24--button__text" @click="toggleService(service)">Удалить</span>
                  </button>
                </div>
              </div>
              <ul class="ais24--selected-subscriptions-card__list">
                <li class="ais24--selected-subscriptions-card__item">
                  <div class="ais24--selected-subscriptions-card__caption">Период подписки</div>
                  <div class="ais24--selected-subscriptions-card__info">
                    <p>{{ getStartDate(service.id) }} до {{ getFinishDate(service) }}</p>
                  </div>
                  <div class="ais24--selected-subscriptions-card__value">{{ getItemSlotsList(service.id).duration }}
                    месяца
                  </div>
                </li>
                <li class="ais24--selected-subscriptions-card__item">
                  <div class="ais24--selected-subscriptions-card__caption">Мест организаций</div>
                  <div class="ais24--selected-subscriptions-card__info">
                    <p>
                      &laquo;{{ getItemSlotsList(service.id).items.map(item => item.name).join('&raquo;, &laquo;') }}&raquo;
                    </p>
                  </div>
                  <div class="ais24--selected-subscriptions-card__value">{{ getSlots(service.id) }} места</div>
                </li>
              </ul>
            </div>

          </div><!--/.ais24--selected-subscriptions-->
        </div><!--/.ais24--details__content-->
        <aside class="ais24--details__sidebar">
          <div class="ais24--calculation">
            <header class="ais24--calculation-header">
              <h3 class="ais24--calculation-header__title">Расчет стоимости:</h3>
            </header><!--/.ais24--calculation-header-->
            <div class="ais24--calculation-body">
              <div class="ais24--calculation-card" v-for="service in getServices()" v-bind:key="service.id">
                <div class="ais24--calculation-card__caption">Сервис</div>
                <ul class="ais24--calculation-card__list">
                  <li class="ais24--calculation-card__item">
                    <strong class="ais24--calculation-card__title">{{ service.name }}</strong>
                    <span class="ais24--calculation-card__info">{{ service.price_per_unit }} ₽/мес. за 1 место</span>
                  </li>
                  <li class="ais24--calculation-card__item">
                    <strong class="ais24--calculation-card__title">Период подписки:</strong>
                    <span class="ais24--calculation-card__info">{{ getItemSlotsList(service.id).duration }} мес. (с {{ getStartDate(service.id) }} до {{ getFinishDate(service) }})</span>
                  </li>
                  <li class="ais24--calculation-card__item">
                    <strong class="ais24--calculation-card__title">{{ getSlots(service.id) }} места
                      организации:</strong>
                    <span class="ais24--calculation-card__info">
                      {{ service.price_per_unit }} ₽ &times; {{ getItemSlotsList(service.id).duration }} мес. &times; {{ getSlots(service.id) }} слот. =
                      <template v-if="getDiscount(service.id)">
                      <s>{{
                          getItemSlotsList(service.id).duration * service.price_per_unit * getSlots(service.id)
                        }} ₽</s>
                                                <strong>{{ getItemSlotsList(service.id).duration * service.price_per_unit * getSlots(service.id) * (100 - getDiscount(service.id))/ 100 }} ₽</strong>
                        </template>
                        <template v-else>
                          <strong>{{ getItemSlotsList(service.id).duration * service.price_per_unit * getSlots(service.id) }} ₽</strong>
                        </template>
                                            </span>
                    <span class="ais24--calculation-card__discount" v-if="getDiscount(service.id)">{{ getDiscount(service.id) }}% скидка</span>
                  </li>
                </ul>
              </div><!--/.ais24--calculation-card-->
            </div><!--/.ais24--calculation-body-->
            <footer class="ais24--calculation-footer">
              <div class="ais24--calculation-total">
                <div class="ais24--calculation-total__text">Итого к оплате:</div>
                <div class="ais24--calculation-total__price">{{ getSum }}&nbsp;₽</div>
              </div><!--/.ais24--calculation-total-->
            </footer><!--/.ais24--calculation-footer-->
          </div><!--/.ais24--calculation-->
        </aside><!--/.ais24--details__sidebar-->
      </div>
    </div>
    <div class="ais24--actions-bar">
      <div class="ais24--container">
        <div class="ais24--actions-bar-holder">
          <div class="ais24--actions-bar-holder__previous">
            <router-link class="ais24--button ais24--button--outline ais24--button--large"
                         :to="{name: 'SubscriptionPage'}">
              <span class="ais24--button__text">Назад</span>
            </router-link>
          </div>
          <div class="ais24--actions-bar-holder__status">Итого к оплате
            <mark>{{ getSum }} рублей</mark>
          </div>
          <div class="ais24--actions-bar-holder__next">
            <router-link class="ais24--button ais24--button--primary ais24--button--large" :to="{name: 'SubscriptionPayPage'}">
              <span class="ais24--button__text">Продолжить</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped lang="scss">
.ais24--dialog .ais24--dialog-body {
  flex: auto;
}
</style>
